import { useState } from "react";
import AppTable from "../../components/shared-components/table/AppTable";
import { CircularProgress } from "@mui/material";
import stylesUser from "../Users/Users.module.css";

interface SuperUserTableProps {
    superUsersList: any;
    setSuperUsersList: (superUsersList: any) => void;
    loading: boolean;
    refetchData:()=>Promise<any>;
}

const SuperUserTable = ({
    loading,
    superUsersList,
    setSuperUsersList,
    refetchData
}: SuperUserTableProps) => {
    const [selected, setSelected] = useState<number[]>([]);
    const [selectedEvents, setSelectedEvents] = useState<string[]>([]);
    const [checking, setChecking] = useState<boolean>(false);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [sortType, setSortType] = useState('asc');
    const [columnTypes, setColumnTypes] = useState('u_name');

    const handleChangeRowsPerPage = (event: any) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setSelected([]);
        setCurrentPage(1);
    }

    const handlePageChange = (_event: any, newPage: number) => {
        setCurrentPage(newPage);
    }

    const GenerateSuperUsersHeadCells = () => {
        const id = ["u_name", "email_id","percentage", "action"]
        const labels = ["User Name","Email Id", "Percentage", "Action"]
        const headCells = id.map((id, index) => ({
            id,
            label: labels[index],
        }));
        return headCells;
    }

   
    return (
        <>
            {
                (loading) ? <div className={stylesUser.TableCircularProgress}>
                    <CircularProgress color="primary" size={35} />
                 </div> :
                    <div style={{ width: '100%' }}>
                        <AppTable
                            handleChangeRowsPerPage={handleChangeRowsPerPage}
                            handlePageChange={handlePageChange}
                            setColumnTypes={setColumnTypes}
                            sortType={sortType}
                            setSortType={setSortType}
                            setSelected={setSelected}
                            setChecking={setChecking}
                            checking={checking}
                            selected={selected}
                            rowsPerPage={rowsPerPage}
                            setCurrentPage={setCurrentPage}
                            currentPage={currentPage}
                            list={superUsersList || []}
                            tableTitle={"superUsersTable"}
                            generateHeadCells={GenerateSuperUsersHeadCells}
                            refetchSuperUsersData={refetchData}
                            setSuperUsersList={setSuperUsersList}
                        />
                    </div>
            }

        </>
    )
}

export default SuperUserTable;
